// extracted by mini-css-extract-plugin
module.exports = {"price":"price_price__Y8TeC","oldPrice":"price_oldPrice__tSyTW"};